import {IconColor} from '@singularit/kurz-components'

// TODO fix file naming
export const calcIconColor = (val: number) => {
  if (!val) return IconColor.DEFAULT
  else if (val > 0) return IconColor.GREEN
  else if (val < 0 && val > -0.5) return IconColor.YELLOW
  else if (val < -0.5) return IconColor.RED
}
